<template>
  <div>
    <div class="row page-titles mb-4">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">Design Cost</h4>
      </div>
      <div class="col-md-7 align-self-center text-right">
        <div class="d-flex justify-content-end align-items-center">
          <breadcrumb :page="currentPage"/>
        </div>
      </div>
    </div>
    <div class="row justify-content-md-end mb-2">
      <div class="col-sm-6 col-md-4">
        <d-text-input placeholder="Search by name..." :value="search.keyword"
                      @input="value => { setSearchField({ key: 'keyword', value }) }"/>
      </div>
      <div class="col-sm-6 col-md-2">
        <d-select-input
            name="status"
            :value="search.status"
            placeholder="Filter status"
            class-name="custom-select"
            :options="statusOptions"
            @input="value => { setSearchField({ key: 'status', value }) }"
        />
      </div>
      <div class="col-sm-6 col-md-1">
        <form-button
            :click="() => gotoSearch(search)"
            type="primary"
            :disabled="loading"
            class="form-control"
        >
          <i class="fa fa-search text-white"/>
        </form-button>
      </div>
    </div>
    <loading-container :loading="loading">
      <div class="d-fj-c d-fa-c d-flex" style="min-height: 300px" v-if="!list || list.length === 0">
        No Design found
      </div>
      <div class="row" v-else>
        <div class="col-sm-12">
          <div class="card">
            <div class="table-responsive">
              <table
                  class="table table-striped dataTable no-footer"
                  style="width: 100%; margin-top: 0 !important;"
              >
                <thead>
                <tr>
                  <th>User</th>
                  <th>Design</th>
                  <th>Number Of Uses</th>
                  <th>Design Cost</th>
                  <th>Last used</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    :class="index % 2 === 0 ? 'odd' : 'even'"
                    v-for="(item, index) in list"
                    :key="index"
                >
                  <td>
                    <div class="d-f-c">
                      <strong>{{ get(item, 'user.name') }}</strong>
                      <span>{{ get(item, 'user.email') }}</span>
                    </div>
                  </td>
                  <td>
                    <div class="d-f-r">
                      <img alt="" :src="get(item, 'emb.thumb')"/>
                      <div class="ml-2">
                        <span>{{ get(item, 'emb.name') }}</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    {{ get(item, 'numberOfUses') }}
                  </td>
                  <td>
                    {{ get(item, 'designCost') | priceDisplay }}
                  </td>
                  <td>
                    {{ item.updatedAt | datetimeDisplay }}
                  </td>
                  <td>
                    <design-cost-status :status="item.status"/>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 d-flex justify-content-center">
          <pagination
              :routeName="routeName"
              :query="search"
              :current="page"
              :total="total"
          />
        </div>
      </div>
    </loading-container>
  </div>
</template>
<style scoped>
img {
  width: 64px;
  height: 64px;
  border: 1px solid #e4e4e4;
  border-radius: 8px;
  object-fit: cover;
}
</style>

<script>
import {mapActions, mapGetters} from "vuex";
import {Datetime} from 'vue-datetime';

import LoadingContainer from "@/components/Misc/LoadingContainer";
import InputSelect from "@/components/Form/InputSelect";
import InputText from "@/components/Form/InputText";
import Pagination from "@/components/Misc/Pagination";
import LinkButton from "@/components/Misc/LinkButton";
import FormButton from "@/components/Form/FormButton";
import Breadcrumb from "@/components/Common/Breadcrumb";
import Uuid from "@/components/Common/Uuid";
import TransactionAmount from "@/components/Common/TransactionAmount";
import PageMixin from "@/mixins/PageMixin";
import DesignCostStatus from "@/components/Views/Design/DesignCostStatus";
import DFormSelect from "@/components/Form/DFormSelect";
import DSelectInput from "@/components/input/DSelectInput";
import DTextInput from "@/components/input/DTextInput";

export default {
  name: "DesignCostManagement",
  mixins: [PageMixin],
  components: {
    DTextInput,
    DSelectInput,
    DFormSelect,
    DesignCostStatus,
    Datetime,
    LoadingContainer,
    InputSelect,
    Pagination,
    LinkButton,
    InputText,
    FormButton,
    Breadcrumb,
    Uuid,
    TransactionAmount,
  },
  mounted() {
    const query = this.$route.query;
    const page = query.page ? parseInt(query.page) : 1;
    const type = query.type;
    const status = query.status;
    const method = query.method;
    const keyword = query.keyword;
    const createdFrom = query.createdFrom;
    const createdTo = query.createdTo;

    this.getDesignCosts({
      page,
      search: {
        type,
        status,
        method,
        keyword,
        createdFrom,
        createdTo
      }
    });
  },
  computed: {
    ...mapGetters({
      list: "designCost/list",
      search: "designCost/search",
      loading: "designCost/loading",
      count: "designCost/count",
      total: "designCost/total",
      page: "designCost/page"
    }),
    statusOptions() {
      return [
        {value: 0, text: 'Not Used'},
        {value: 1, text: 'Pending payment'},
        {value: 2, text: 'Paid'},
        {value: 3, text: 'Refunded'},
      ];
    },
  },
  methods: {
    ...mapActions({
      getDesignCosts: "designCost/getDesignCosts",
      setSearchField: "designCost/setSearchField",
    }),
    gotoSearch(query) {
      this.$router.push({name: this.routeName, query});
    },
    doApproveTransaction(transactionId) {
      if (confirm("Are you sure to confirm this transaction?")) {
        this.approveTransaction(transactionId);
      }
    },
    submitExport(query) {
      this.getReports({query});
    },
  }
};
</script>
